import App from '../components/app';
import Page from '../containers/page';
import Projects from '../containers/projects';
import Project from '../containers/project';

const routes = [
  {
    component: App,
    routes: [
      {
        path: '/',
        exact: true,
        component: Page,
      },
      {
        path: '/about',
        exact: true,
        component: Page,
      },
      {
        path: '/contact',
        exact: true,
        component: Page,
      },
      {
        path: '/works/:slug',
        exact: true,
        component: Projects,
      },
      {
        path: '/project/:slug',
        component: Project,
      },
    ],
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js